<template>
  <div
    class="content-meet-btn"
    :style="{
      display: extraItem.extras('mettingicon.display') == 1 ? 'block' : 'none',
    }"
  >
    <div
      class="u-meet-con"
      @click="showModal"
      v-show="extraItem.extras('mettingicon.display')"
    >
      <img
        :src="extraItem.extras('mettingicon.src')"
        :alt="extraItem.extras('mettingicon.display')"
      />
    </div>
    <a-modal
      class="wap-meet-modal"
      v-model="visible"
      title="会议详情"
      @ok="handleOk"
      footer
    >
      <Meeting :seminarInfo="seminarInfo" />
    </a-modal>
  </div>
</template>
<script>
import Meeting from "@/components/Meeting.vue";
import * as sbaseData from "../common/sbase";

export default {
  name: "WapMeetEntry",
  props: ["platform", "seminarInfo"],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
  components: {
    Meeting,
  },
  data() {
    return {
      visible: false,
      needVerify: "",
      contactId: "",
      meetUrl: require("@/assets/images/wap/icon-meeting.png"),
    };
  },
  methods: {
    showModal() {
      if (!sbaseData.isSetting) {
        this.visible = true;
      }
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
